import { QuestionDefinition, QuestionVariety } from "./Definition";
import { validatorFunc, visibilityFunc } from "./Question";
import { SingleValueQuestion } from "./SingleValueQuestion";

export default class ToDoQuestion extends SingleValueQuestion {
  get type(): QuestionVariety {
    return "todo";
  }

  // to-do questions are always valid
  constructor(
    def: QuestionDefinition,
    isVisible: visibilityFunc | undefined,
    validator: validatorFunc | undefined
  ) {
    super(def, isVisible, () => ({ isValid: true, errorText: "" }));
    this.answer = "@todo-question";
  }
}
